import React from 'react';
import PropTypes from 'prop-types';
import { PsLinkLabel } from './ps-link-label/PsLinkLabel';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { AuthContext } from '../../../shared/routing/AuthContext';

export const WorkLabel = (
    {
        work,
    },
) => {
    const { currentUser } = React.useContext(AuthContext);

    if ( !work ) {
        return null;
    }

    const workName = work.name();
    const to = currentUser.canSeeOutsources() ?
        RouterUtils.generateRoute(
            PsRoutes.MY_OUTSOURCES_WORKS_DETAIL,
            {
                id: work.id(),
            },
        ) : undefined;

    return (
        <PsLinkLabel
            to={to}
            label={workName}
        />
    );
};

WorkLabel.propTypes = {
    work: PropTypes.object,
};

WorkLabel.defaultProps = {
    work: null,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/WorkLabel.jsx